import { Redirect } from "expo-router";

const TakeChallengesRoute = () => {
	return <Redirect href={"/library"} />;
};

export default TakeChallengesRoute;
